    <template>
  <div v-if="isLoaded">
    <div v-if="rate !== 'error'">
      <h2>{{ $t('ratesDetails') }}</h2>
      <el-button
        v-if="!rate.confirmed_at"
        style="float: right; font-size: 20px; margin-left: 10px"
        type="primary"
        icon="el-icon-edit"
        @click="$router.push({name: 'RateEdit', params: {rate: rate, isEdit: true}})"
      />
      <el-card>
        <table>
          <tr>
            <td class="res-name">{{ $t('ratesConfirm') }}</td>
            <td class style="text-align: left">
              <div v-if="rate.confirmed_at">
                <i class="el-icon-check" style="color: green; font-size: 20px"/>
              </div>
              <div v-else>
                <i class="el-icon-close" style="color: red; font-weight: bolder; font-size: 16px"/>
              </div>
            </td>
          </tr>
          <tr>
            <td class="res-name">{{ $t('ratesProvider') }}</td>
            <td class="res-value">
              <lang-tabs-view
                :param="{name: 'SingleProvider', params: {id: rate.provider.id}}"
                :input="rate.provider ? rate.provider.display_name : ''"
              />
            </td>
          </tr>
          <tr>
            <td class="res-name">{{ $t('ratesDistributor') }}</td>
            <td class="res-value">
              <lang-tabs-view
                :param="rate.distributor ? {name: 'SingleProvider', params: {id: rate.distributor.id}} : {}"
                :input="rate.distributor ? rate.distributor.display_name : ''"
              />
            </td>
          </tr>
          <tr>
            <td class="res-name">{{ $t('ratesCustomerType') }}</td>
            <td class>{{rate.customer_type ? rate.customer_type.description[locale] : '/'}}</td>
          </tr>
          <tr>
            <td class="res-name">{{ $t('ratesContractTerm') }}</td>
            <td class>{{rate.contract_term ? rate.contract_term + ' months' : '/'}}</td>
          </tr>
          <tr>
            <td class="res-name">{{ $t('ratesMeterType') }}</td>
            <td class>{{ meterType }}</td>
          </tr>
          <tr>
            <td class="res-name">{{ $t('ratesSeasonType') }}</td>
            <td class>{{ seasonType }}</td>
          </tr>
          <tr>
            <td class="res-name">{{ $t('ratesPowerMeasurement') }}</td>
            <td class>{{ powerType }}</td>
          </tr>
          <tr>
            <td class="res-name">{{ $t('ratesConsumptionType') }}</td>
            <td
              class
            >{{rate.small_consumer ? $t('ratesSmallConsumerLabel') : $t('ratesBigConsumerLabel')}}</td>
          </tr>
          <tr>
            <td class="res-name">{{ $t('ratesSeasonDescription') }}</td>
            <td class="res-value">
              <lang-tabs-view :input="rate.season_description ? rate.season_description : ''"/>
            </td>
          </tr>
          <!-- <tr>
                    <td class="res-name"> {{ $t('ratesCreatedBy') }} </td>
                    <td class="res-value-clickable" @click="$router.push({name: 'SingleUser', params: {id: rate.created_by.id}})">{{rate.created_by ? rate.created_by.name : '/'}}</td>
          </tr>-->
          <tr>
            <td class="res-name">{{ $t('ratesCreatedAt') }}</td>
            <td class>{{rate.created_at ? rate.created_at.date.slice(0,19) : '/'}}</td>
          </tr>
          <!-- <tr>
                    <td class="res-name"> {{ $t('ratesUpdatedBy') }} </td>
                    <td class="res-value-clickable" @click="rate.updated_by ? $router.push({name: 'SingleUser', params: {id: rate.created_by.id}}) : ''">{{rate.updated_by ? rate.updated_by.name : '/'}}</td>
          </tr>-->
          <tr>
            <td class="res-name">{{ $t('ratesUpdatedAt') }}</td>
            <td class>{{rate.updated_at ? rate.updated_at.date.slice(0,19) : '/'}}</td>
          </tr>
          <!-- <tr>
                    <td class="res-name"> {{ $t('ratesConfirmedBy') }} </td>
                    <td class="res-value-clickable" @click="$router.push({name: 'SingleUser', params: {id: rate.confirmed_by.id}})">{{rate.confirmed_by ? rate.confirmed_by.name : '/'}}</td>
          </tr>-->
          <tr>
            <td class="res-name">{{ $t('ratesConfirmedAt') }}</td>
            <td class>{{rate.confirmed_at ? rate.confirmed_at.slice(0,19) : '/'}}</td>
          </tr>
          <tr>
            <td class="res-name">{{ $t('ratesPublishedAt') }}</td>
            <td class>{{rate.published_at ? rate.published_at.slice(0,19) : '/'}}</td>
          </tr>
        </table>
      </el-card>
      <br>
      <h2>{{ $t('ratesTariffs') }}</h2>
      <el-card>
        <table>
          <tr>
            <td class="res-name">{{ $t('ratesActiveEnergyHT') }}</td>
            <td
              class
            >{{rate.active_energy_vt && rate.active_energy_vt > -1 ? rate.active_energy_vt : '/'}}</td>
          </tr>
          <tr>
            <td class="res-name">{{ $t('ratesActiveEnergyLT') }}</td>
            <td
              class
            >{{ rate.active_energy_mt === 0 || rate.active_energy_mt ? rate.active_energy_mt : '/'}}</td>
          </tr>
          <tr>
            <td class="res-name">{{ $t('ratesBillingCapacityHT') }}</td>
            <td
              class
            >{{ rate.billing_capacity_vt === 0 || rate.billing_capacity_vt ? rate.billing_capacity_vt : '/'}}</td>
          </tr>
          <tr>
            <td class="res-name">{{ $t('ratesBillingCapacityLT') }}</td>
            <td
              class
            >{{ rate.billing_capacity_mt === 0 || rate.billing_capacity_mt ? rate.billing_capacity_mt : '/'}}</td>
          </tr>
          <tr>
            <td class="res-name">{{ $t('ratesEnergyEfficiency') }}</td>
            <td
              class
            >{{ rate.energy_efficiency === 0 || rate.energy_efficiency ? rate.energy_efficiency : '/'}}</td>
          </tr>

          <tr>
            <td class="res-name">{{ $t('ratesLossHT') }}</td>
            <td class>{{ rate.loss_vt === 0 || rate.loss_vt ? rate.loss_vt : '/'}}</td>
          </tr>
          <tr>
            <td class="res-name">{{ $t('ratesLossLT') }}</td>
            <td class>{{ rate.loss_mt === 0 || rate.loss_mt ? rate.loss_mt : '/'}}</td>
          </tr>

          <tr>
            <td class="res-name">{{ $t('ratesMeteringPoint') }}</td>
            <td
              class
            >{{ rate.metering_point === 0 || rate.metering_point ? rate.metering_point : '/'}}</td>
          </tr>

          <tr>
            <td class="res-name">{{ $t('ratesNetworkCapacity') }}</td>
            <td
              class
            >{{ rate.network_capacity === 0 || rate.network_capacity ? rate.network_capacity : '/'}}</td>
          </tr>
          <tr>
            <td class="res-name">{{ $t('ratesFixedNetworkCapacity') }}</td>
            <td
              class
            >{{ rate.fixed_network_capacity === 0 || rate.fixed_network_capacity ? rate.fixed_network_capacity : '/'}}</td>
          </tr>
          <tr>
            <td class="res-name">{{ $t('ratesOIE') }}</td>
            <td class>{{ rate.OIE === 0 || rate.OIE ? rate.OIE : '/'}}</td>
          </tr>
          <tr>
            <td class="res-name">{{ $t('ratesOperator') }}</td>
            <td class>{{ rate.operator === 0 || rate.operator ? rate.operator : '/'}}</td>
          </tr>
          <tr>
            <td class="res-name">{{ $t('ratesReactiveEnergyHT') }}</td>
            <td
              class
            >{{ rate.reactive_energy_vt === 0 || rate.reactive_energy_vt ? rate.reactive_energy_vt : '/'}}</td>
          </tr>
          <tr>
            <td class="res-name">{{ $t('ratesReactiveEnergyLT') }}</td>
            <td
              class
            >{{ rate.reactive_energy_mt === 0 || rate.reactive_energy_mt ? rate.reactive_energy_mt : '/'}}</td>
          </tr>
          <tr>
            <td class="res-name">{{ $t('ratesRenewable') }}</td>
            <td class>{{ rate.renewable === 0 || rate.renewable ? rate.renewable : '/'}}</td>
          </tr>
        </table>
      </el-card>

      <view-shared-buttons redirectPath="Rates"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import api from "@/api/api";
import LangTabsView from "../LangTabs/LangTabsView";
import LayoutHeaders from "../LayoutPart/LayoutHeaders";
import NotFound from "../NotFound";
import ViewSharedButtons from "../Shared/ViewSharedButtons";
import fields from '@/model/dropdownTypes';

export default {
  components: {
    LayoutHeaders,
    LangTabsView,
    NotFound,
    ViewSharedButtons
  },
  data() {
    return {
      emptyText: "",
      rate: {},
      isLoaded: false,
      meterTypes: fields.meterTypes
    };
  },
  computed: {
    ...mapGetters({
      locale: "getLocale"
    }),
    meterType () { 
      let {meter_type} = this.rate;
      return meter_type === 'single_rate_meter' ? 
        this.$t('meterTypeLabelSingle') 
        : this.$t('meterTypeLabelSingle');
    },
    powerType () {
      let { power_measurement } = this.rate;
      if (power_measurement === 'with') {
        return this.$t('powerTypeLabelWith');
      } else if (power_measurement === 'without') {
        return this.$t('powerTypeLabelWithout');
      } else if (power_measurement === 'with_reactive') {
        return this.$t('powerTypeLabelWithReactive');
      } else return '/';
    },
    seasonType () {
      let { season_type } = this.rate;
      if (season_type === 'high') return this.$t('seasonTypeLabelHigh');
      else if (season_type === 'low') return this.$t('seasonTypeLabelLow');
      else if (season_type === 'no_season') return this.$t('seasonTypeLabelNoSeason');
      else return '/';
    }
  },
  async created() {
    let rate;
    await api
      .fetchSingleRate(this.$route.params.id)
      .then(res => {
        rate = res.data.data;
      })
      .catch(err => {
        rate = "error";
      });
    this.rate = rate;
    this.isLoaded = true;
  }
};
</script>

<style scoped>
h2 {
  color: grey;
  font-weight: 500;
  margin-left: 5px;
  display: inline-block;
}

table {
  width: 100%;
}

table > tr > td {
  padding: 15px !important;
  border-bottom: 1px solid #e6e6e6;
}

table > tr:last-child > td {
  border: none;
}

table > tr > td:nth-child(2) {
  position: relative;
  margin-left: -3px;
  display: block;
  margin-top: 1px;
  font-size: 16px;
}

.res-value-clickable {
  color: #409eff !important;
  cursor: pointer;
}

.res-name {
  width: 300px;
  color: grey;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 10px;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/Rates/RateView.vue